import type { AppChannel, UserRole } from '@pressteaze/domain';

export interface AuthenticatedUser {
	readonly id: string;
	readonly full_name: string;
	readonly role: UserRole;
	readonly channels: readonly AppChannel[];
}

export interface ConfigurationLoginResponse {
	readonly access_token: string;
	readonly refresh_token: string;
	readonly expires_in: number;
	readonly user: AuthenticatedUser;
}

export interface OperatorStore {
	readonly id: string;
	readonly name: string;
}

export interface OperatorSession {
	readonly session_id: string;
	readonly user_id: string;
	readonly store_id: string;
	readonly full_name: string;
	readonly store_name: string;
	readonly expires_at: string;
}

export interface OperatorSessionResponse {
	readonly session_token: string;
	readonly session: OperatorSession;
}

export interface OperatorSessionRestoreResponse {
	readonly session: OperatorSession;
}

export interface OperatorStoreChallenge {
	readonly login_challenge: string;
	readonly stores: readonly OperatorStore[];
	readonly default_store_id: string | null;
	readonly expires_in: number;
}

export type OperatorLoginResponse =
	OperatorSessionResponse | OperatorStoreChallenge;

export function isStoreChallenge(
	value: OperatorLoginResponse,
): value is OperatorStoreChallenge {
	return 'login_challenge' in value;
}
